import { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import apiService from '../../Auth/apiService';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { useAuth } from './../../Auth/AuthContext';
import { BotonEditar } from '../Utils/BotonEditar';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';


export default function Sedes(){
    const { token } = useAuth();
    const [sedes, setSedes] = useState([]);
    const [programas, setProgramas] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarsede';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar sede', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar sede', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar sede', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('sedNombre', '');
        setValue('sedPrograma', 0);
        setValue('sedActivo', 0);
        setMuestraFormulario(false);
    }
    const NuevoRol = () =>  {
        setValue('id', 0);
        setValue('sedNombre', '');
        setValue('sedPrograma', 0);
        setValue('sedActivo', 0);
        setMuestraFormulario(true);
    }

    function handleEdit (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('sedNombre', row.sedNombre);
        setValue('sedPrograma', row.sedPrograma);
        setValue('sedActivo', row.sedActivo);
    };
    async function ConsultarProgramasSecretaria(){
        const url = '/parametros/listarprogramassecretaria';
        try {
            const response = await apiService.get(url, token)
            setProgramas(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        ConsultarProgramasSecretaria();
    }, []);

    const fetchData = async () => {
        const url = '/parametros/listarsedes';
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setSedes(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        fetchData();
        }, []);

    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Sedes"
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parámetros"
                nombreform=" sede"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario sedes</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='sedNombre'>Sede</label>
                                                <input id='sedNombre' {...register('sedNombre', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Sede"/>
                                                {errors.sedNombre && <p style={{color: 'red'}}>Digitar sede</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <label htmlFor='sedPrograma'>Programa secretar&iacute;a</label>
                                                <select
                                                    id='sedPrograma'
                                                    {...register('sedPrograma', { required: true })}
                                                    className="form-control"
                                                >
                                                    <option value="">Seleccione un programa</option>
                                                    {programas.map(programa => (
                                                        <option key={programa.id} value={programa.id}>
                                                            {programa.proPrograma}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.sedPrograma && <p style={{color: 'red'}}>Seleccione un programa</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('sedActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button type="button" className='form-control' onClick={NuevoRol}>Nuevo</button>
                                <div className="table-responsive">
                                    <h5>Lista de sedes</h5>
                                    <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>Id</th>
                                                <th>Nombre</th>
                                                <th>Programa Id</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Cargando ? (
                                                <tr>
                                                    <td colSpan={5} className="text-center">Cargando...</td>
                                                </tr>
                                            ) : sedes.length === 0 ? (
                                                <tr>
                                                    <td colSpan={5} className="text-center">No hay datos para mostrar</td>
                                                </tr>
                                            ) : (
                                                sedes.map((row, idx) => (
                                                    <tr key={row.id || idx}>
                                                        <td>
                                                            <BotonEditar Editar={handleEdit} row={row}/>
                                                        </td>
                                                        <td>{row.id}</td>
                                                        <td>{row.sedNombre}</td>
                                                        <td>{row.sedPrograma}</td>
                                                        <td>{row.sedActivo ? 'Activo' : 'Inactivo'}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    );
}